export enum SettingKeys {
  CASHFLOW = 'cashflow',
  CASHBACK = 'cashback',
  AZERPOST = 'azerpost',
  MAIL = 'mail',
  TRENDYOL = 'trendyol',
  OTHERS = 'others',
  TOPUP = 'topup',
}

export type ISettings = {
  configs: {
    sendDeclarationsToCustoms: boolean;
    orders: {
      cashRegisterId: string | null;
    };
    terminal: {
      cashRegisterId: string | null;
    };
  };
  countries: {
    abbr: string;
    box: number;
    country: string;
    code: string;
    name: string;
    currency: string;
    id: number;
    stateId: string;
    unit: string;
  }[];
  workingHours: string;
  bonPercent: string;
  contact: {
    id: number;
    number: string;
    email: string;
    name: string;
    address: string;
    map: string;
  }[];
  foreignWarehouses: {
    addressHeading: string;
    address: string;
    province: string;
    countryName: string;
    id: number;
    district: string;
    country: string;
    phone: string;
  }[];
};

export type ISettingsPersistence = {
  contact: {
    id: number;
    number: string;
    name: string;
    email: string;
    address: string;
    map: string;
  }[];
  countries: {
    abbr: string;
    box: number;
    country: string;
    country_code: string;
    country_name: string;
    currency: string;
    id: number;
    state_id: string;
    unit: string;
  }[];
  cashbox_id: string | null;
  terminal_cashbox_id: string | null;
  workinghours: string | null;
  bon_percent: string | null;
  customs: number;
  warehouse: {
    address_heading: string;
    address: string;
    province: string;
    district: string;
    id: number;
    country: string;
    country_name: string;
    phone: string;
  }[];
};

export type ISettingsCashflow = {
  cashboxId: string;
  terminalCashboxId: string;
};

export type ISettingsCashflowPersistent = {
  cashbox_id: string;
  terminal_cashbox_id: string;
  group_id: string;
};

export type ISettingsCashback = {
  cashbackPercent: string;
  expired: string;
  cashbackMax: string;
  cashbackMin: string;
  cashbackBalance: string;
  cashbackAvtoMax: string;
};

export type ISettingsCashbackPersistent = {
  group_id: string;
  cashback_expired: string;
  cashback_percent: string;
  cashback_max: string;
  cashback_min: string;
  cashback_balance: string;
  cashback_avto_max: string;
};

export type IOthersSettings = {
  customs: number;
  orderPercent: string;
  orderStatus: number;
  bigPackage: string;
  whatsapp: number;
  smallPackage: string;
  mediumPackage: string;
  declarationStatus: number;
  courierStatus: number;
};

export type IOthersSettingsPersistent = {
  customs: string;
  order_percent: string;
  order_status: string;
  whatsapp: string;
  declaration_status: string;
  package_price: {
    medium_package: number;
    small_package: number;
    big_package: number;
  };
  courier_status: string;
  group_id: 'others';
};
export type IMailSettings = {
  ticketHtmlTemplateId: string;
  footerText: string;
  headerBannerUrl: string;
  rightBannerUrl: string;
  headerBannerPhoto: any;
  rightBannerPhoto: any;
};

export type IMailSettingsPersistent = {
  ticket_html_template_id: string;
  footer_text: string;
  header_banner_url: string;
  right_banner_url: string;
  header_banner_photo: any;
  right_banner_photo: any;
};

export type IBranchesSettings = {
  id: string;
  numbers: string;
  emails: string;
  address: string;
  map: string;
  number: string;
  email: string;
  name: string;
};
export type IBranchesSettingsPersistent = {
  id: string;
  numbers: string;
  emails: string;
  address: string;
  map: string;
  number: string;
  email: string;
  name: string;
  group_id: string;
};
export type IBranchesSettingsDtoPersistent = {
  group_id: string;
  items: {
    id: string;
    numbers: string;
    emails: string;
    address: string;
    map: string;
    number: string;
    email: string;
    name: string;
    group_id: string;
  }[];
};
export type IWarehouseSettings = {
  id: string;
  city: string;
  addressHeading: string;
  postalCode: string;
  passportIdentity: string;
  address: string;
  province: string;
  district: string;
  country: string;
  phone: string;
};
export type IWarehouseSettingsPersistent = {
  id: string;
  city: string;
  address_heading: string;
  postal_code: string;
  passport_identity: string;
  address: string;
  province: string;
  district: string;
  country: string;
  phone: string;
};
export type ISettingsAzerPost = {
  weightPrice: string;
  standardPrice: string;
};

export type ISettingsAzerPostPersistent = {
  weight_price: string;
  standart_price: string;
  group_id: string;
};

export type ISettingTrendyol = {
  shippingCostUsd: number;
};

export type ISettingTrendyolPersistent = {
  shipping_cost_usd: number;
};
